export default [
    {
        path: '/voucher/list',
        name: 'voucher_list',
        component: () => import('@src/voucher/voucher-list'),
        meta: {
            title: 'Alle Gutscheine',
            role: 'ROLE_LIST_VOUCHER',
        },
    },
    {
        path: '/voucher/edit/:id',
        name: 'voucher_edit',
        component: () => import('@src/voucher/voucher-edit'),
        props(route) {
            const props = { ...route.params };
            props.id = Number(props.id);

            return props;
        },
        meta: {
            title: 'Gutschein bearbeiten',
            role: 'ROLE_EDIT_VOUCHER',
        },
    },
    {
        path: '/voucher/create',
        name: 'voucher_create',
        component: () => import('@src/voucher/voucher-create'),
        meta: {
            title: 'Gutschein anlegen',
            role: 'ROLE_EDIT_VOUCHER',
        },
    },
];
